// extracted by mini-css-extract-plugin
export default {"section":"ShopWelcomeSection_section__peucD","section_children":"ShopWelcomeSection_section_children__COLC5"};